export default __webpack_public_path__ + "static/media/golden-sun.afdb5b27.jpg";